import React from 'react';
import { Box, Typography, styled } from '@mui/material';

const Page403 = () => {
  return (
    <Container>
      <Typography variant="h1" color="error">
        403
      </Typography>
      <Typography variant="h5" sx={{ mt: 2 }}>
        Forbidden
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        You don't have permission to access this resource.
      </Typography>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  textAlign: 'center'
});

export default Page403;
